function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M75,133.4c-30.6,0-55.5-24.9-55.5-55.5S44.4,22.4,75,22.4s55.5,24.9,55.5,55.5S105.6,133.4,75,133.4z M75,27.7 c-27.7,0-50.2,22.5-50.2,50.2s22.5,50.2,50.2,50.2c27.7,0,50.2-22.5,50.2-50.2S102.7,27.7,75,27.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M22.3,80.5L22,75.3c0.5,0,55.5-3.9,106.1,0l-0.4,5.3C77.4,76.6,22.9,80.5,22.3,80.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M77.6,131.1l-5.2-0.6c1.7-13.8,0-104.4,0-105.3l5.3-0.1C77.7,28.7,79.3,116.9,77.6,131.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M85.6,131l-4.5-2.7c14-23,18.5-46.9,13.2-71.1c-3.9-18-12.1-29.5-12.2-29.6l4.3-3.1C86.8,25,120.9,73,85.6,131 z"
}), React.createElement("path", {
  className: "st0",
  d: "M64.2,131c-18.4-30.3-17.7-57.6-13.8-75.2c4.2-19.1,12.7-30.8,13-31.3l4.3,3.1c-0.3,0.5-32.4,45.7,1,100.6 L64.2,131z"
}), React.createElement("path", {
  className: "st0",
  d: "M121.6,55.7c-60.2-2.8-92.7,0-93,0l-0.5-5.2c0.3,0,33.1-2.9,93.7,0L121.6,55.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M70.5,103.8c-27.6,0-42.2-1.3-42.4-1.3l0.5-5.2c0.3,0,32.8,2.8,93,0l0.2,5.3 C101.5,103.4,84.4,103.8,70.5,103.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M76.3,125.1c-18.5,0-32.5-1.8-32.7-1.8l0.7-5.2c0.3,0,31.1,4,61.5,0l0.7,5.2C96,124.6,85.6,125.1,76.3,125.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M44.2,38l-0.7-5.2c0.3,0,31.8-4.1,62.9,0l-0.7,5.2C75.4,34,44.5,38,44.2,38z"
}));

var SvgNetworkSettingsIcon = function SvgNetworkSettingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNetworkSettingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/network-settings-icon.923d9c69.svg";
export { ForwardRef as ReactComponent };